var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('habit-name'),_c('habit-small-action'),_c('habit-alternate-action'),_c('habit-description'),_c('button-save')],1)}
var staticRenderFns = []

export { render, staticRenderFns }